import React from "react";
import { createPortal } from "react-dom";
import { styled } from "styled-components";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 1000;
`

const ModalContainer = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #f7f7f7;
    padding: 25px;
    transitionL 300ms;
    z-index: 1000;
    min-width: 80vw;
    @media (min-width: 768px) {
        min-width: 0;
    }
`

const CloseButton = styled.button`
    background-image: none;
    cursor: pointer;
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: 0!important;
    margin: 0;
    border-style: inherit;
    border-color: #F05A26;
    box-sizing: border-box;
    border-width: 0!important;
    position: absolute;
    right: -14px;
    top: -18px;
    padding: 0!important;
    border-radius: 9999px!important;
    background-color: #F05A26!important;
    transition: 300ms;
    color: #ffffff;
    transition: 300ms;
    display: flex;
    width: 34px;
    height: 34px;
    justify-content: center;
    align-items: center;
    &:hover {
        background-color: #ffffff!important;
        color: #F05A26!important;
        & svg {
            fill: #F05A26;
        }
    }
`

function Modal({ children, open, onClose }) {
    if (!open) return null;

    if (open) {
        document.body.style.overflow = "hidden";
    }

    const onClodeHandler = () => {
        onClose();
        document.body.style.overflow = "auto";
    };

    return createPortal(
        <>
            <Backdrop onClick={onClodeHandler} />
            <ModalContainer>
                <CloseButton
                    type="button"
                    onClick={onClodeHandler}
                    title="Close the calendar">
                    <CloseIcon fill="#fff" />
                </CloseButton>
                {children}
            </ModalContainer>
        </>,
        document.getElementById("r-portal")
    );
}

export default Modal;
